module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/battle//result-title_lost.png?v=48c926bb";